import { ExternalLink, Files as F, Paperclip, ScanQrCode, SquarePen, Trash2, Video } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useDispatch, useSelector } from 'react-redux';

import QRLink from '@/components/Modal/Project/QRLink';
import Delete from '@/components/Modal/Project/Delete';
import Files from '@/components/Modal/Project/Files';
import useVideoUrl from '@/hooks/useVideoUrl';
import { route } from '@/constants/routeName';

export default function ProjectLink({ project, from = 'project', type = '', }) {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	const [openQR, setOpenQR] = useState(false);
	const [deleteProject, setDeleteProject] = useState(null);
	const [openAttachments, setOpenAttachments] = useState(null);

	const id = type === 'parent' ? project.productid : project.componentid || project.productid;
	const isDisableFiles = !project.attachment_in_component;
	const prefixDetail = project.productprefix_detail;
	const isVideo = prefixDetail
		? prefixDetail[0]?.productprefix === 'BD-VIDEO'
		: project.component_prefix_name === 'BD-VIDEO' || project.productprefix === 'BD-VIDEO';
	const vUrl = project?.producturl || project?.component_producturl;

	const { videoUrl } = useVideoUrl(project, isVideo, vUrl);
	const p = {
		name: project.productname || project.component_productname,
		number: project.productcodenumber || project.component_code_number,
		...videoUrl,
	};
	const isAction = [1, 2, 3, 4].includes(user?.privilegelevelid);
	return (
		<div className='flex justify-center gap-1 '>
			{from === 'project' && (
				<>
					<button
						className='p-1 rounded-sm btn-action hover:bg-bd-bg'
						onClick={() => {
							const code = project.component_code_number || project.productcodenumber;
							const ver = project.component_productversion || project.productversion;
							window.open(window.location.origin + '/project/' + code + (ver && ver != '-' ? '_' + ver : '') + `/${id}`, '_blank');
						}}
						title='Åpne produkt i ny fane'
					>
						<ExternalLink size={16} />
					</button>
					{isAction && (
						<Link to={`/${route.project}/edit/${id}`} className='p-1 rounded-sm btn-action hover:bg-bd-bg' title='Endre produkt'>
							<SquarePen size={16} />
						</Link>
					)}
					{isVideo && (
						<button
							className='p-1 rounded-sm btn-action hover:bg-bd-bg'
							onClick={(e) => {
								e.stopPropagation();
								dispatch({ type: 'trigger/triggerAPI', payload: { key: 'showVideo', value: p } });
							}}
							title="Se video"
						>
							<Video size={16} />
						</button>
					)}
					{isAction && (
						<Link to={`/${route.project}/duplicate/${id}`} className='p-1 rounded-sm hover:bg-bd-bg' title='Kopiere produkt'>
							<F size={16} />
						</Link>
					)}
					{isAction && (
						<button
							className='p-1 rounded-sm btn-action hover:bg-bd-bg'
							onClick={(e) => {
								e.stopPropagation();
								setDeleteProject(true);
							}}
							title="Slette product"
						>
							<Trash2 size={16} />
						</button>
					)}
					<button
						onClick={() => {
							if (!isDisableFiles) setOpenAttachments(id);
						}}
						className={twMerge('btn-action p-1 rounded-sm hover:bg-bd-bg', isDisableFiles && 'cursor-not-allowed')}
						disabled={isDisableFiles}
						title="Se vedlegg"
					>
						<Paperclip size={16} className={isDisableFiles && 'opacity-50'} />
					</button>
					<button
						className='p-1 rounded-sm btn-action hover:bg-bd-bg'
						onClick={(e) => {
							e.stopPropagation();
							setOpenQR(true);
						}}
						title="QR kode"
					>
						<ScanQrCode size={16} />
					</button>
				</>
			)}

			{from === 'files' && (
				<>
					<button
						onClick={(e) => {
							e.stopPropagation();
							if (!isDisableFiles) setOpenAttachments(id);
						}}
						className={twMerge('btn-action p-1 rounded-sm hover:bg-bd-bg', isDisableFiles && 'cursor-not-allowed')}
						disabled={isDisableFiles}
					>
						<Paperclip size={16} className={isDisableFiles && 'opacity-50'} />
					</button>
					{isVideo && (
						<button
							className='p-1 rounded-sm btn-action hover:bg-bd-bg'
							onClick={(e) => {
								e.stopPropagation();
								dispatch({ type: 'trigger/triggerAPI', payload: { key: 'showVideo', value: p } });
							}}
						>
							<Video size={16} />
						</button>
					)}
				</>
			)}

			{openQR && <QRLink open={!!openQR} onClose={() => setOpenQR(false)} project={project} />}
			{deleteProject && <Delete open={!!deleteProject} id={id} project={project} onClose={() => setDeleteProject(false)} />}
			{!isDisableFiles && openAttachments && (
				<Files open={!!openAttachments} id={id} project={project} onClose={() => setOpenAttachments(false)} from={from} />
			)}
		</div>
	);
}
